<template>
  <div class="card-form">
    <PageHeader
      ref="header"
      @query="getData"
      @reset="resetPage"
      @confirm="$emit('confirm')"
      @cancel="$emit('cancel')"
    >
    </PageHeader>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :tableHeight="tableHeight"
      @reload="reload"
      @checkbox-change="checkboxChange"
    >
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  props: { tableHeight: { type: Number, default: 300 } },
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return { 
      usePage: true, 
      checkedRows: [],
      preSelectedFabrics: [], // 预先选中的面料
    }
  },
  mounted() {
    // 弹框打开时自动加载数据
    this.$nextTick(() => {
      if (this.$refs.header) {
        this.$refs.header.query()
      }
    })
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSkuSpecFabricChooseFabricListApi({
          ...form,
          ...this.page,
          fabricOwner: 'ecomAmazon',
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          // 数据加载后，恢复之前选中的面料
          this.$nextTick(() => {
            this.restoreSelection()
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkboxChange(data) {
      this.checkedRows = data
      this.$emit('checkbox-change', data)
    },
    getSelectedFabrics() {
      return this.checkedRows
    },
    clearCheckboxRow() {
      if (this.$refs.main) {
        this.$refs.main.clearCheckboxRow()
      }
      this.checkedRows = []
      this.preSelectedFabrics = []
    },
    // 设置预先选中的面料
    setSelectedFabrics(fabrics) {
      this.preSelectedFabrics = fabrics || []
      this.restoreSelection()
    },
    // 恢复选中状态
    restoreSelection() {
      if (!this.$refs.main || !this.preSelectedFabrics.length || !this.tableData.length) return

      const table = this.$refs.main.$refs.table
      if (!table) return

      // 先清空当前页所有选中（跨页保留的会自动保持）
      table.clearCheckboxRow()

      // 遍历预选的面料
      this.preSelectedFabrics.forEach((fabric) => {
        // 先找当前页是否有这行
        let row = this.tableData.find(r => r.fabricCode === fabric.fabricCode)
        
        // 如果当前页有，直接选中
        if (row) {
          table.setCheckboxRow(row, true)
        } else {
          // 如果当前页没有，但你有完整的 fabric 对象（包含 fabricCode 和其他字段）
          // 直接传 fabric 对象，vxe-table 会自动存入 reserve（跨页保留）
          table.setCheckboxRow(fabric, true)
        }
      })

      // 获取所有选中（当前页 + 跨页保留）
      const records = table.getCheckboxRecords()
      const reserves = table.getCheckboxReserveRecords()
      this.checkedRows = records.concat(reserves)
      this.$emit('checkbox-change', this.checkedRows)
    },
  },
}
</script>

